( function( app ) {
  const COMPONENT = {
    init: function() {
      const updateMobileMenuClearance = function() {
        const primaryNav = document.querySelector( '#primary-nav' );

        if ( !primaryNav ) return;

        if ( !window.matchMedia( '(max-width: 1023px)' ).matches ) {
          primaryNav.style.removeProperty( '--navigationTwoMobileScrollClearance' );
          return;
        }

        const mobileCtas = primaryNav.querySelector( '.navigation-two__mobile-ctas' );
        const mobileCtaHeight = mobileCtas && mobileCtas.getClientRects().length ? mobileCtas.getBoundingClientRect().height : 0;

        primaryNav.style.setProperty( '--navigationTwoMobileScrollClearance', `${mobileCtaHeight + 32}px` );
      };

      updateMobileMenuClearance();
      $( window ).on( 'resize.navigationTwoMobileClearance', updateMobileMenuClearance );
      $( '.navbar-toggle' ).on( 'toggleAfter', updateMobileMenuClearance );

      const closeOpenChildMenus = function() {
        $( '.primary-menu-item__link.is-open' ).each( function() {
          $( this ).trigger( 'click' );
        } );
      };

      const syncClosedPrimaryNav = function() {
        const $primaryNav = $( '#primary-nav' );

        $( '.navbar-toggle, #primary-nav' ).removeClass( 'is-open' );

        $primaryNav
            .stop( true, false )
            .fadeOut( 150, function() {
              $( this ).hide();
            } );
      };

      document.addEventListener( 'click', function( event ) {
        const toggle = event.target.closest( '.navbar-toggle' );
        const closeButton = event.target.closest( '.close-nav-panel' );

        if ( ( toggle && $( '#primary-nav' ).hasClass( 'is-open' ) ) || closeButton ) {
          closeOpenChildMenus();
        }
      }, true );

      $( '.close-nav-panel' ).on( 'click', function() {
        closeOpenChildMenus();

        setTimeout( function() {
          syncClosedPrimaryNav();
        }, 0 );
      } );

      $( '.navbar-toggle' ).on( 'toggleBefore', function() {
        if ( $( this ).hasClass( 'is-open' ) ) {
          closeOpenChildMenus();
        }
      } );

      if ( $( window ).width() > 1024 ) {
        // ADA close menu when focus shifts outside of it
        const handleFocusNav = function( navOpen ) {
          if ( navOpen ) {
            $( '.nav-open__focus' ).trigger( 'focus' );
            $( document ).on( 'keyup.navClose', function( event ) {
              if ( event.which === 27 ) {
                $( '.navbar-toggle' ).trigger( 'focus' );
                $( '.navbar-toggle' ).trigger( 'click' );
              }
            } );
          } else {
            $( document ).off( 'keyup.navClose' );
          }
        };
        $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
          if ( window.easyToggleState.isActive( event.target ) ) {
            /* handle ADA focus */
            handleFocusNav( true );
          } else {
            /* handle ADA focus */
            handleFocusNav( false );
          }
        } );

        // ADA close menu when focus shifts outside of it
        $( '.navigation-two-panel' ).on( 'focusout', function( e ) {
          const newFocus = e.relatedTarget;

          if ( newFocus === null ) return;

          setTimeout( function() {
            const activeElement = document.activeElement;
            const focusIsInPrimaryNav = $( '#primary-nav' ).has( activeElement ).length > 0;
            const focusIsOnNavbarToggle = $( activeElement ).hasClass( 'navbar-toggle' );

            if ( !focusIsInPrimaryNav && !focusIsOnNavbarToggle ) {
              $( '.navbar-toggle' ).trigger( 'click' );
              $( '.navbar-toggle' ).trigger( 'focus' );
            }
          }, 75 );
        } );

        // ADA send focus to first menu item when child menu is open
        $( '.primary-menu-item__link' ).on( 'toggleAfter', function( event ) {
          if ( window.easyToggleState.isActive( event.target ) ) {
            const target = $( this ).attr( 'data-toggle-target' );
            const firstLink = $( target ).find( 'a' ).get( 0 );
            setTimeout( () => {
              firstLink.focus();
            }, 50 );
          }
        } );

        // child-menu-panel
        $( '.child-menu-panel' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          const panelBackBtn = $menuItem.find( 'button.nav-two__back-btn' ).get( 0 );

          if ( !$menuItem.has( newFocus ).length ) {
            $( panelBackBtn ).trigger( 'click' );
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-two', COMPONENT );
} )( app );
